export let FollowButtonSize = /*#__PURE__*/function (FollowButtonSize) {
  FollowButtonSize["Compact"] = "compact";
  FollowButtonSize["Full"] = "full";
  FollowButtonSize["Large"] = "large";
  FollowButtonSize["Normal"] = "normal";
  FollowButtonSize["Small"] = "small";
  FollowButtonSize["Thin"] = "thin";
  return FollowButtonSize;
}({});
export let FollowButtonVariant = /*#__PURE__*/function (FollowButtonVariant) {
  FollowButtonVariant["Dark"] = "dark";
  FollowButtonVariant["Homepage"] = "homepage";
  FollowButtonVariant["Light"] = "light";
  FollowButtonVariant["Style"] = "magazines-style";
  return FollowButtonVariant;
}({});
export let FollowButtonOutline = /*#__PURE__*/function (FollowButtonOutline) {
  FollowButtonOutline["Filled"] = "filled";
  FollowButtonOutline["Outlined"] = "outlined";
  FollowButtonOutline["Plain"] = "plain";
  return FollowButtonOutline;
}({});
export let FollowButtonDisplay = /*#__PURE__*/function (FollowButtonDisplay) {
  FollowButtonDisplay["BluePlusIcon"] = "blue-plus-icon";
  FollowButtonDisplay["BlueSquareIcon"] = "blue-square-icon";
  FollowButtonDisplay["CircleGrayIcon"] = "circle-gray-icon";
  FollowButtonDisplay["Text"] = "text";
  return FollowButtonDisplay;
}({});
export let FollowButtonAction = /*#__PURE__*/function (FollowButtonAction) {
  FollowButtonAction["Follow"] = "follow";
  FollowButtonAction["Unfollow"] = "unfollow";
  return FollowButtonAction;
}({});
export let FollowType = /*#__PURE__*/function (FollowType) {
  FollowType["Author"] = "author";
  FollowType["Section"] = "section";
  FollowType["Topic"] = "topic";
  return FollowType;
}({});
export const isFollowType = type => Object.values(FollowType).includes(type);